import {WalletTransferContext} from '#/components/wallet-transfer/wallet-transfer-context';
import {WalletTransferTab} from '#/components/wallet-transfer/wallet-transfer-tab';
import * as Tabs from '@radix-ui/react-tabs';
import {FunctionComponent, useContext} from 'react';

interface Props {
  children: React.ReactNode;
  className: string;
}

export const WalletTransferTabsRoot: FunctionComponent<Props> = ({children, className, ...rest}) => {
  const {tab, setTab} = useContext(WalletTransferContext);
  const onValueChange = (value: string) => {
    setTab(value as WalletTransferTab);
  };

  return (
    <Tabs.Root className={className} value={tab} onValueChange={onValueChange} {...(rest as any)}>
      {children}
    </Tabs.Root>
  );
};
